import { createSlice } from "@reduxjs/toolkit";

// Mirrors the wineriesSlice "active context switch" pattern, but the
// impersonation access token is kept only in memory (via AuthProvider.setAuth)
// and never persisted to storage — the session is short-lived (15 min) and
// there is no dedicated refresh endpoint for it (see useAxiosPrivate.js).
export const impersonationSlice = createSlice({
    name: 'impersonation',
    initialState: {
        active: null, // { targetUserId, targetUsername, adminId, adminUsername }
        savedAdminAuth: null, // auth object of the admin who started impersonating, to restore on exit
    },
    reducers: {
        startImpersonating: (state, action) => {
            return {
                active: action.payload.active,
                savedAdminAuth: action.payload.savedAdminAuth,
            };
        },
        stopImpersonating: () => {
            return {
                active: null,
                savedAdminAuth: null,
            };
        },
    },
});

export const { startImpersonating, stopImpersonating } = impersonationSlice.actions;

export default impersonationSlice.reducer;
